module.exports = __webpack_public_path__ + "static/logo-bfc265bd0c44ac833eec1ccf523c377d.png";